import { Inbox, LayoutDashboard } from "lucide-react";

/** Admin template navigation — Bookly-style grouped sidebar. */
const sidebarConfig = () => [
  {
    label: "Main",
    items: [
      {
        title: "Overview",
        path: "/dashboard",
        icon: LayoutDashboard,
        exact: true,
      },
      {
        title: "Contacts",
        path: "/contacts",
        icon: Inbox,
      },
    ],
  },
];

export default sidebarConfig;
